import React from 'react';
import PropTypes from 'prop-types';
import { LapsCounterWrapper, LapLabel } from './styles';
import Label from '../../shared/Label';

const LapsCounter = ({
  currenteLap,
  laps,
  justify,
  safetyCar,
}) => (
  <LapsCounterWrapper justify={justify}>
    <LapLabel
      color="liveColor"
      font="narrowMedium"
    >
      {`Giro ${currenteLap} di ${laps}`}
      {safetyCar &&
        <Label
          label=" (Safety car) "
          size={0.8}
          color="liveColor"
        />
      }
    </LapLabel>
  </LapsCounterWrapper>
);

LapsCounter.propTypes = {
  currenteLap: PropTypes.any,
  laps: PropTypes.any,
  justify: PropTypes.any,
  safetyCar: PropTypes.bool,
};

export default LapsCounter;
